import { useCurrentUser } from '@/hooks/user'
export function enableAuth(val) {
  let flag = true
  const buttonPermissions = useCurrentUser().buttonPermissions.value || []
  if (!buttonPermissions.length) {
    return fasle
  }
  // 可以传入字符串和数组
  if (typeof val === 'string') {
    flag = buttonPermissions.includes(val)
  } else {
    // 如果传入数组，只要数组中任意一个值和当前pageAuth code或者role匹配就会显示。
    flag = val.some(item => buttonPermissions.includes(item))
  }
  return flag
}

/**
 *  v-focus="true"
 *  自动聚焦
 *
 */
const focus = {
  mounted: (el, binding) => {
    if (binding.value == true || binding.value == undefined) {
      el.querySelector('input').focus()
    }
  }
}

/**
 *  v-permiss="['hot-list', 'hot-c']"
 * 控制按钮的显示与隐藏
 *
 */
const permiss = {
  mounted: (el, binding) => {
    const val = binding.value
    // 测试看数据暂时返回true
    const flag = enableAuth(val)
    if (!flag) {
      if (el.parentNode) {
        el.parentNode?.removeChild(el)
      } else {
        el.style.display = 'none'
      }
    }
  }
}

export const directivesList = {
  focus,
  permiss
}
